import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useEffect, useMemo, useRef, useState } from 'react';
import { IppicaNazioneDto, IppicaTipoScommessaDto } from 'types/swagger';
import { getQuoteFinali } from './actions';
import { initIppicaQuoteFinali } from './ippicaSlice';
import { selectCavalloFactory } from './selectors';
import { TabValue } from './types';

export type IppicaMenuProps = {
  type: TabValue;
};

export type IppicaNavHookType = {
  data: Array<IppicaNazioneDto>;
  isLoading: boolean;
};

export const useInterval = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef<() => void | null>(() => {});

  // Ricorda l'ultimo callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Imposta l'intervallo.
  useEffect(() => {
    const tick = () => {
      if (savedCallback?.current) {
        savedCallback.current();
      } else {
        return;
      }
    };
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    } else {
      return;
    }
  }, [delay]);
};

export const useGetCavallo = (key: string) => {
  const selectCavallo = useMemo(selectCavalloFactory, [key]);

  return useTypedSelector((st) => selectCavallo(st, key));
};

export const useFetchData = (list: Array<IppicaTipoScommessaDto>) => {
  //codiceTipoScommessa: number) => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState<Array<any> | null>(null);
  // const [count, setCount] = useState<number>(0);
  useEffect(() => {
    const fetchData = async () => {
      const promises = list.map(async (item) => {
        const response = await dispatch(getQuoteFinali({ codiceTipoScommessa: item.codiceTipoScommessa }));

        !!response && dispatch(initIppicaQuoteFinali({ data: response, isLoading: false }));
        return response!;
      });

      const responses = await Promise.all(promises);
      setData([...responses]);
      // setCount(responses.length);
    };

    fetchData();
  }, [dispatch]);

  return { data };
};

export const useHasCampiActive = (tipoScommessaSelected: string | undefined) => {
  const hasCampi = useMemo(() => {
    return (
      tipoScommessaSelected &&
      tipoScommessaSelected !== '1' &&
      tipoScommessaSelected !== '2' &&
      tipoScommessaSelected !== '0-VIN'
    );
  }, [tipoScommessaSelected]);
  return hasCampi;
};
